var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ValidationProvider', {
    staticClass: "form-group w-full",
    class: _vm.$attrs.class,
    attrs: {
      "rules": _vm.customRules,
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_vm.label ? _c('label', {
          staticClass: "block text-base font-normal mb-1",
          class: _vm.labelClass
        }, [_vm._v(_vm._s(_vm.label)), _vm.isRequired ? _c('b', {
          staticClass: "ml-1 text-red-600 font-bold"
        }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('div', {
          staticClass: "relative input-group h-[42px]"
        }, [_vm.leftIcon ? _c('div', {
          staticClass: "icon-left"
        }, [_c('i', {
          class: _vm.leftIcon
        })]) : _c('div', {
          staticClass: "icon-left z-10"
        }), _c('date-range-picker', _vm._b({
          attrs: {
            "appendToBody": true,
            "autoApply": true,
            "controlContainerClass": _vm.controlContainerClass,
            "date-format": _vm.dateFormatFn,
            "disabled": _vm.disabled,
            "linkedCalendars": false,
            "locale-data": _vm.localeData,
            "opens": _vm.opens,
            "ranges": false,
            "showDropdowns": true,
            "showWeekNumbers": false,
            "singleDatePicker": _vm.singleDatePicker,
            "time-picker": false,
            "timePicker": false,
            "timePicker24Hour": true
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function (pickerProps) {
              return [_c('i', {
                staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
              }), _vm._v("  "), _c('span', {
                class: _vm.placeHolderClass
              }, [_vm._v(_vm._s(_vm.rangeText))]), _c('b', {
                staticClass: "caret"
              })];
            }
          }], null, true),
          model: {
            value: _vm.dateRange,
            callback: function ($$v) {
              _vm.dateRange = $$v;
            },
            expression: "dateRange"
          }
        }, 'date-range-picker', _vm.$attrs.input, false)), _vm.rightIcon ? _c('div', {
          staticClass: "icon-right"
        }, [_c('i', {
          class: _vm.rightIcon,
          on: {
            "click": function ($event) {
              return _vm.$emit('rightIconClick');
            }
          }
        })]) : _vm._e(), _vm._t("right-icon"), _c('div', {
          staticClass: "dropdown relative"
        })], 2), _c('span', {
          staticClass: "text-xs text-red-600"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, true)
  });

}
var staticRenderFns = []

export { render, staticRenderFns }